export default __webpack_public_path__ + "static/media/Blog12.4.cf8f4fd9.png";